import React, { useEffect, useState } from 'react'
import { FaChevronCircleDown } from 'react-icons/fa'
import CustomInput from '../../Components/Input/CustomInput'
import { FiUpload } from 'react-icons/fi'
import DatePicker from '../../Components/Input/DatePicker'
import { RiAddFill } from 'react-icons/ri'
import {
  FIND_ALL_UNIQUE_CAR_BRANDS,
  FIND_CARS_BY_BRAND,
} from '../../Services/cabggl'
import Select from '../../Components/Autocompelte/Select'
import { useLazyQuery, useQuery } from '@apollo/client'
import sedanImage from '../../Components/Assets/sedan.png'
import suvImage from '../../Components/Assets/suv.png'
import premsuvImage from '../../Components/Assets/prem-suv.png'

const FleetCabReg = ({ carDetails, setCarDetails, errors }) => {
  const [carforms, setCarForms] = useState([0])
  const [formVisibility, setFormVisibility] = useState([true])
  const [minDateCurrentDate, setMinDateCurrentDate] = useState('')
  const [nextCarFormNumber, setNextCarFormNumber] = useState(1)
  const [selectedBrand, setSelectedBrand] = useState([])
  const [carModels, setCarModels] = useState([])
  const [carOptions, setCarOptions] = useState([])
  const { loading, error, data } = useQuery(FIND_ALL_UNIQUE_CAR_BRANDS)
  const [getCarsByBrand, { data: modelData }] = useLazyQuery(FIND_CARS_BY_BRAND)

  useEffect(() => {
    setCarForms(carDetails.map((_, index) => index)) // This ensures forms are re-rendered when data changes
  }, [carDetails])

  useEffect(() => {
    if (data) {
      const formattedBrands = data.findAllUniqueBrands.map((brand) => ({
        label: brand,
        value: brand,
      }))
      setCarModels(formattedBrands)
    }
  }, [data])

  useEffect(() => {
    const today = new Date()
    const formattedToday = today.toISOString().split('T')[0]
    setMinDateCurrentDate(formattedToday)
  }, [])

  useEffect(() => {
    if (modelData) {
      const formattedOptions = modelData.findCarsByBrand.map((car) => ({
        label: `${car.brand} - ${car.variant}`,
        value: `${car.brand} - ${car.variant}`,
        carType: car?.carType,
      }))
      setCarOptions(formattedOptions)
    }
  }, [modelData])

  const toggleFormVisibility = (index) => {
    const newVisibility = [...formVisibility]
    newVisibility[index] = !newVisibility[index]
    setFormVisibility(newVisibility)
  }
  const handleAddCar = () => {
    const newCarNumber = nextCarFormNumber
    setCarForms([...carforms, newCarNumber]) // Add the new car form number
    setFormVisibility((prevVisibility) => [...prevVisibility, true])
    setCarDetails((prevCarDetails) => [
      ...prevCarDetails,
      {
        carOwnerName: '',
        rcBook: '',
        carNo: '',
        permit: '',
        puc: '',
        color: '',
        variant: '',
        registrationDate: '',
        registrationExpiryDate: '',
        insuranceExpiryDate: '',
        insurance: '',
        googleLocation: '',
      },
    ])
    setNextCarFormNumber(newCarNumber + 1) // Increment the next car number
  }
  const handleInputChange = (index, fieldName, value) => {
    // Ensure we're updating an object at the given index
    const updatedCarDetails = [...carDetails] // Make a copy of the array
    updatedCarDetails[index] = {
      ...updatedCarDetails[index], // Spread the existing object at that index
      [fieldName]: value, // Update the field dynamically
    }
    setCarDetails(updatedCarDetails) // Set the updated array
  }
  const handleBrandChange = async (index, fieldName, value) => {
    // Ensure we're updating an object at the given index
    const updatedCarDetails = [...carDetails] // Make a copy of the array
    updatedCarDetails[index] = {
      ...updatedCarDetails[index], // Spread the existing object at that index
      [fieldName]: value, // Update the field dynamically
    }
    try {
      // Trigger the lazy query with the updated brand variable
      await getCarsByBrand({
        variables: { brand: value?.value },
      })
      setCarDetails(updatedCarDetails)
    } catch (err) {
      console.error('Error during refetch:', err)
    }
  }

  const handleSelectCarAndCartype = async (index, value) => {
    const updatedCarDetails = [...carDetails]
    updatedCarDetails[index] = {
      ...updatedCarDetails[index],
      variant: value?.value,
      carType: value?.carType,
    }
    await setCarDetails(updatedCarDetails)
  }

  const handleCarFileChange = (event, index, field) => {
    const file = event.target.files[0]
    if (file) {
      const updatedCarDetails = [...carDetails]
      updatedCarDetails[index][field] = file
      setCarDetails(updatedCarDetails)
    }
    // validateCarDetials()
  }

  const handleCarCancelForm = (index) => {
    if (index === 0) {
      return // Prevent removing the first form
    }

    const newForms = carforms.filter((_, i) => i !== index)
    const newVisibility = formVisibility.filter((_, i) => i !== index)
    const newCarDetails = carDetails.filter((_, i) => i !== index)

    setCarForms(newForms)
    setFormVisibility(newVisibility)
    setCarDetails(newCarDetails)
    setNextCarFormNumber(nextCarFormNumber - 1)
  }

  const calculateMinDateRange = (index) => {
    if (!carDetails?.[index]?.registrationDate) return null
    const registrationDate = new Date(!carDetails?.[index]?.registrationDate)
    const minDate = registrationDate.toISOString().substr(0, 10)
    return minDate
  }

  const calculateMaxDateRange = (index) => {
    if (!carDetails?.[index]?.registrationDate) return null
    const registrationDate = new Date(carDetails?.[index]?.registrationDate)
    const maxDate = new Date(
      registrationDate.setFullYear(registrationDate.getFullYear() + 5)
    )
      .toISOString()
      .substr(0, 10)

    return maxDate
  }
  return (
    <div>
      <div className="mt-5">
        <div className="w-full text-start text-stone-500 text-sm md:text-xl font-bold">
          Register Fleet Car
        </div>
        <div>
          {carforms.map((formIndex, index) => (
            <div key={formIndex} className="mt-5">
              <div className="w-full flex justify-between items-center text-start text-stone-500 text-sm md:text-base font-bold">
                <span>Car {index + 1}</span>
                <span
                  onClick={() => toggleFormVisibility(index)}
                  className="cursor-pointer"
                >
                  <FaChevronCircleDown
                    size={20}
                    style={{
                      transform: formVisibility[index]
                        ? 'rotate(0deg)'
                        : 'rotate(180deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </span>
              </div>
              {/* {/ Line Under the Form /} */}
              {formVisibility[index] && (
                <div className="w-full h-[1px] bg-gray-300 mt-2"></div>
              )}
              {formVisibility[index] && (
                <div className="mt-2">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                    <div>
                      <CustomInput
                        placeholderValue={'Car Owner'}
                        labelValue={'Car Owner Name'}
                        required
                        name={`carowner_${formIndex}`}
                        value={carDetails[index]?.carOwnerName || ''}
                        onChange={(text) =>
                          handleInputChange(index, 'carOwnerName', text)
                        }
                      />
                      {errors[index]?.carOwnerName && (
                        <small className="text-red-500">
                          {errors[index]?.carOwnerName}
                        </small>
                      )}
                    </div>
                    <div>
                      <div className="flex gap-1 w-full flex-col text-start max-w-96">
                        <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                          Rc Book
                        </label>
                        <div>
                          <input
                            type="file"
                            accept="application/pdf,image/jpeg,image/png,"
                            onChange={(event) =>
                              handleCarFileChange(event, index, 'rcBook')
                            }
                            className="hidden"
                            id={`rc-book-upload-${index}`}
                          />
                          <label
                            htmlFor={`rc-book-upload-${index}`}
                            className="bg-sky-500 w-20 md:w-24 px-2 py-1.5 rounded text-xs md:text-base font-semibold flex items-center gap-2 text-white cursor-pointer"
                          >
                            <span>
                              <FiUpload color="#fff" />
                            </span>
                            Upload
                          </label>
                        </div>
                        {carDetails[index]?.rcBook?.name && (
                          <div className="mt-2 text-sm text-stone- justify-between flex align-middle underline">
                            <span>{carDetails[index]?.rcBook?.name}</span>
                          </div>
                        )}
                        {errors[index]?.rcBook && (
                          <small className="text-red-500">
                            {errors[index]?.rcBook}
                          </small>
                        )}
                      </div>
                    </div>
                    <div>
                      <CustomInput
                        placeholderValue={'MH12TW5106'}
                        labelValue={'Car no.'}
                        required
                        name={`carNo_${formIndex}`}
                        formatCarNumber
                        onChange={(text) =>
                          handleInputChange(index, 'carNo', text)
                        }
                        value={carDetails[index]?.carNo.toUpperCase() || ''}
                      />
                      {errors[index]?.carNo && (
                        <small className="text-red-500">
                          {errors[index]?.carNo}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                    <div>
                      <div className="flex gap-1 w-full flex-col text-start max-w-96">
                        <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                          Permit
                        </label>
                        <div>
                          <input
                            type="file"
                            accept="application/pdf,image/jpeg,image/png,"
                            onChange={(event) =>
                              handleCarFileChange(event, index, 'permit')
                            }
                            className="hidden"
                            id={`permit-upload-${index}`}
                          />
                          <label
                            htmlFor={`permit-upload-${index}`}
                            className="bg-sky-500 w-20 md:w-24 px-2 py-1.5 rounded text-xs md:text-base font-semibold flex items-center gap-2 text-white cursor-pointer"
                          >
                            <span>
                              <FiUpload color="#fff" />
                            </span>
                            Upload
                          </label>
                        </div>
                        {carDetails[index]?.permit?.name && (
                          <div className="mt-2 text-sm text-stone- justify-between flex">
                            <span>{carDetails[index]?.permit?.name}</span>
                          </div>
                        )}
                        {errors[index]?.permit && (
                          <small className="text-red-500">
                            {errors[index]?.permit}
                          </small>
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="flex gap-1 w-full flex-col text-start max-w-96">
                        <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                          PUC
                        </label>
                        <div>
                          <input
                            type="file"
                            accept="application/pdf,image/jpeg,image/png,"
                            onChange={(event) =>
                              handleCarFileChange(event, index, 'puc')
                            }
                            className="hidden"
                            id={`puc-upload-${index}`}
                          />
                          <label
                            htmlFor={`puc-upload-${index}`}
                            className="bg-sky-500 md:w-24 w-20 px-2 py-1.5 rounded md:text-base text-xs font-semibold flex items-center gap-2 text-white cursor-pointer"
                          >
                            <span>
                              <FiUpload color="#fff" />
                            </span>
                            Upload
                          </label>
                        </div>
                        {carDetails[index]?.puc?.name && (
                          <div className="mt-2 text-sm text-stone- justify-between flex">
                            <span>{carDetails[index]?.puc?.name}</span>
                          </div>
                        )}
                        {errors[index]?.puc && (
                          <small className="text-red-500">
                            {errors[index]?.puc}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-1 w-full flex-col text-start max-w-96">
                      <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                        Insurance
                      </label>
                      <div>
                        <input
                          type="file"
                          accept="application/pdf,image/jpeg,image/png,"
                          onChange={(event) =>
                            handleCarFileChange(event, index, 'insurance')
                          }
                          className="hidden"
                          id={`insurance-upload-${index}`}
                        />
                        <label
                          htmlFor={`insurance-upload-${index}`}
                          className="bg-sky-500 w-20 md:w-24 px-2 py-1.5 rounded text-xs md:text-base font-semibold flex items-center gap-2 text-white cursor-pointer"
                        >
                          <span>
                            <FiUpload color="#fff" />
                          </span>
                          Upload
                        </label>
                      </div>
                      {carDetails[index]?.insurance?.name && (
                        <div className="mt-2 text-sm text-stone- justify-between flex">
                          <span>{carDetails[index]?.insurance?.name}</span>
                        </div>
                      )}
                      {errors[index]?.insurance && (
                        <small className="text-red-500">
                          {errors[index]?.insurance}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                    <div>
                      <DatePicker
                        labelValue="Registration Date / RC"
                        selected={carDetails[index]?.registrationDate}
                        onChange={(value) => {
                          handleInputChange(index, 'registrationDate', value)
                        }}
                        minDate={(() => {
                          const date = new Date()
                          date.setFullYear(date.getFullYear() - 5)
                          return date.toISOString().split('T')[0]
                        })()}
                        maxDate={new Date().toISOString().split('T')[0]}
                      />
                      {errors[index]?.registrationDate && (
                        <small className="text-red-500">
                          {errors[index]?.registrationDate}
                        </small>
                      )}
                    </div>
                    <div>
                      <DatePicker
                        labelValue="Registration Expiry Date"
                        selected={carDetails[index]?.registrationExpiryDate}
                        onChange={(value) => {
                          handleInputChange(
                            index,
                            'registrationExpiryDate',
                            value
                          )
                        }}
                        disable={!carDetails?.[index]?.registrationDate}
                        maxDate={calculateMaxDateRange(index)}
                        minDate={calculateMinDateRange(index)}
                      />
                      {errors[index]?.registrationExpiryDate && (
                        <small className="text-red-500">
                          {errors[index]?.registrationExpiryDate}
                        </small>
                      )}
                    </div>
                    <div>
                      <DatePicker
                        labelValue="Insurance Expiry Date"
                        selected={carDetails[index]?.insuranceExpiryDate}
                        onChange={(value) => {
                          handleInputChange(index, 'insuranceExpiryDate', value)
                        }}
                        minDate={minDateCurrentDate}
                        maxDate={(() => {
                          const maxDate = new Date()
                          maxDate.setFullYear(maxDate.getFullYear() + 1)
                          return maxDate.toISOString().split('T')[0]
                        })()}
                      />
                      {errors[index]?.insuranceExpiryDate && (
                        <small className="text-red-500">
                          {errors[index]?.insuranceExpiryDate}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                    <div>
                      <DatePicker
                        labelValue="Permit Expiry Date"
                        selected={carDetails[index]?.permitExpiryDate}
                        onChange={(value) => {
                          handleInputChange(index, 'permitExpiryDate', value)
                        }}
                        minDate={minDateCurrentDate}
                        maxDate={(() => {
                          const maxDate = new Date()
                          maxDate.setFullYear(maxDate.getFullYear() + 2) // Set maxDate to 1 year from today
                          return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                        })()}
                      />
                      {errors[index]?.permitExpiryDate && (
                        <small className="text-red-500">
                          {errors[index]?.permitExpiryDate}
                        </small>
                      )}
                    </div>
                    <div>
                      <DatePicker
                        labelValue="PUC Expiry Date"
                        selected={carDetails[index]?.pucExpiryDate}
                        onChange={(value) => {
                          handleInputChange(index, 'pucExpiryDate', value)
                        }}
                        minDate={minDateCurrentDate}
                        maxDate={(() => {
                          const maxDate = new Date()
                          maxDate.setFullYear(maxDate.getFullYear() + 1) // Set maxDate to 1 year from today
                          return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                        })()}
                      />
                      {errors[index]?.pucExpiryDate && (
                        <small className="text-red-500">
                          {errors[index]?.pucExpiryDate}
                        </small>
                      )}
                    </div>
                    <div>
                      <CustomInput
                        placeholderValue={'Color'}
                        labelValue={'Color'}
                        required
                        name={`color_${formIndex}`}
                        onChange={(text) =>
                          handleInputChange(index, 'color', text)
                        }
                        value={carDetails[index]?.color || ''}
                      />
                      {errors[index]?.color && (
                        <small className="text-red-500">
                          {errors[index]?.color}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                    <div className="flex gap-2">
                      <Select
                        labelValue={'Select Brand'}
                        selected={carDetails?.brand}
                        onSelect={(value) => {
                          handleBrandChange(index, 'brand', value)
                        }}
                        placeholderValue={'Please select brand'}
                        options={carModels}
                      />
                    </div>
                    <div>
                      <Select
                        labelValue={'Select Model'}
                        selected={{
                          label: carDetails[index]?.variant,
                          value: carDetails[index]?.variant,
                        }}
                        onSelect={(value) =>
                          handleSelectCarAndCartype(index, value)
                        }
                        placeholderValue={'Please select model'}
                        options={carOptions}
                      />
                      {errors[index]?.variant && (
                        <small className="text-red-500">
                          {errors[index]?.variant}
                        </small>
                      )}
                    </div>
                    <div>
                      <label className="text-stone-700 text-xs font-semibold mt-2">
                        Car Type - {carDetails?.[index]?.carType}
                      </label>

                      {carDetails[index]?.carType === 'sedan' && (
                        <img src={sedanImage} />
                      )}
                      {carDetails[index]?.carType === 'SUV' && (
                        <img src={suvImage} />
                      )}
                      {carDetails[index]?.carType === 'PREMIUM SUV' && (
                        <img src={premsuvImage} />
                      )}
                    </div>
                  </div>
                  <div className="mt-5">
                    <button
                      onClick={() => handleCarCancelForm(index)}
                      className="bg-red-500 px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white md:text-base"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
          <div className="mt-5 flex justify-start gap-4">
            <button
              onClick={handleAddCar}
              className="bg-sky-500 md:text-base px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80"
            >
              <RiAddFill size={20} />
              Add Car
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FleetCabReg
